module.exports = "<uia-rights-flow\n  should-show-rights-options=\"model.shouldShowRightsOptions\"\n></uia-rights-flow>\n";